import { parser } from '@copera/tiptap/markdown';
import { ConversationMessageContent } from '@modules/conversation-message/ConversationMessageContent';
import { Typography } from '@mui/material';
import type { Editor } from '@tiptap/react';
import { useMemo } from 'react';
import { AiChatMessage } from 'src/@types/ai';
import { ConversationMessageContentType } from 'src/@types/conversation';
import { IUser } from 'src/@types/user';
import { IWorkspaceUser } from 'src/@types/workspace-info';
import { AISearchThinkResponse } from 'src/sections/@dashboard/ai/Chat/AIConversation/AIMessages/AIMessageContent/AISearchThinkResponse';

type Props = {
  message: AiChatMessage;
  sender: IUser | IWorkspaceUser | undefined;
  editor: Editor;
};
export const AIMessageContent = ({ message, sender, editor }: Props) => {
  if (message.error) {
    return (
      <Typography variant="subtitle2" color="error" mt={1}>
        {message?.error}
      </Typography>
    );
  }

  if (message.role === 'user') {
    const parsedContent = useMemo(
      () => (message.content ? parser.parse(message.content).toJSON() : ''),
      [message.content],
    );

    return (
      <ConversationMessageContent
        message={{
          contentType: ConversationMessageContentType.TEXT,
          _id: message._id,
          createdAt: message.createdAt,
          author: sender!._id,
          content: parsedContent,
        }}
        editor={editor}
      />
    );
  }

  return <AISearchThinkResponse message={message} editor={editor} />;
};
